import { topic, topic_select } from "@Modules/Topic/configs/constants";

import list_topic from "./reducers";
import list_topic_select from "./reducers/topicSelect";

export default {
  [topic]: list_topic,
  [topic_select]: list_topic_select,
};
